import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css";
import ContactForm from "../../../../COMPONENTS/FORM/CONTACT";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

const ContactSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="contact-section">
      <Container>
        <Row className="align-items-start">
          <Col xs={12} className="text-center mb-4">
            <h2 className="contact_title" data-aos="fade-up">
              Contact Us
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} className="order-md-1" data-aos="fade-right">
            <div data-aos="fade-in" className="mt-5">
              <strong>Practices: Bring KUR Diagnostics to Your Clinic</strong>
            </div>
            <ContactForm />
          </Col>
          <Col xs={12} md={6} className="order-md-2" data-aos="fade-left">
            <div className="text-left">
              <div data-aos="fade-in" className="mt-5">
                <strong>Patients: Schedule an Appointment</strong>
              </div>
              <div data-aos="fade-in" className="mt-4">
                KUR Diagnostics is a turn-key, physician-based cardiac screening
                program.
              </div>
              <div data-aos="fade-in" className="mt-4">
                <strong>To Schedule an Appointment,</strong>
                <span className="subtext mt-4">
                  {" "}
                  please contact your nearest location in{" "}
                  <a href="/locations/texas" className="highlight">
                    Texas
                  </a>{" "}
                  and{" "}
                  <a href="/locations/oklahoma" className="highlight">
                    Oklahoma
                  </a>{" "}
                  and tell them you'd like to "get a KUR Diagnostics screening."
                </span>
              </div>
              <div className="subtext mt-4" data-aos="fade-in">
                At this time, please do not use the form on this website for
                scheduling an appointment.
              </div>
              <address data-aos="fade-in" className="mt-4">
                <strong>Clinic Support Center</strong>
                <span className="subtext mt-4">
                  <br />
                  2425 Cedar Springs Road
                  <br />
                  Dallas, Texas 75201
                  <br />
                  United States
                </span>
              </address>
              <div data-aos="fade-in" className="mt-4">
                <strong>Locations</strong>
                <span className="subtext">
                  {" "}
                  KUR Diagnostics is located in clinics and physician offices
                  across Texas and Oklahoma. Please contact your provider to see
                  if they offer KUR Diagnostics or visit our Locations page to
                  find the nearest location.
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactSection;
